/**
 * Garage Request Flow View
 * Multi-step wizard wrapper for the new LLM-powered request flow
 */

import React from 'react';
import GarageRequestFlow from './GarageRequestFlow';

const GarageRequestFlowView = ({ userEmail, userName, onNavigate }) => {
  const handleBack = () => {
    if (onNavigate) {
      onNavigate('requests');
    }
  };

  const handleSubmit = () => {
    if (onNavigate) {
      onNavigate('requests');
    }
  };

  return (
    <GarageRequestFlow
      userEmail={userEmail}
      userName={userName}
      onBack={handleBack}
      onSubmit={handleSubmit}
    />
  );
};

export default GarageRequestFlowView;


